
import './App.css';
import Header from './components/Header';
import Title from './components/Title';
import Footer from './components/Footer';
function App() {
  return (
    <div className="App">
    <Header></Header>
    <Title></Title>
    <Footer></Footer>
    </div>
  );
}

export default App;
